import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import { TextButton } from "components/Button";
import ExternalLink from "components/ExternalLink";
import Icon from "components/Icon";
import Text from "components/Text";
import { useCurrentTenant } from "contexts/currentTenant";
import useDownload from "hooks/useDownload";
import { useCurrentGuide } from "queries/guides";

import styles from "./HelpBar.scss";

const HelpBar = ({ noPadding, showPrint, DownloadButton }) => {
  const tenant = useCurrentTenant();
  const { data: guide } = useCurrentGuide();
  const externalHelpURL = guide?.external_help_url;

  if (!showPrint && !DownloadButton && !externalHelpURL) {
    return null;
  }

  const linkContent = (
    <>
      <Icon size="lg" icon="comment" />
      <span>
        <Text t="guides.help_bar.need_help" />{" "}
      </span>
      <em>
        <Text
          t="guides.help_bar.contact"
          municipalityType={tenant.municipality_type.toLowerCase()}
        />
      </em>
    </>
  );
  return (
    <div className={classnames(styles.wrapper)}>
      <div
        className={classnames(styles.container, {
          [styles.noPadding]: noPadding,
        })}
      >
        {showPrint && (
          <span className={styles.print}>
            <TextButton onClick={window.print}>
              <Icon size="lg" icon="print" />
              <span>
                <Text t="guides.help_bar.print" />
              </span>
            </TextButton>
          </span>
        )}

        {DownloadButton && <DownloadButton />}

        <span className={styles.help} data-help>
          {externalHelpURL && <ExternalLink href={externalHelpURL}>{linkContent}</ExternalLink>}
        </span>
      </div>
    </div>
  );
};
HelpBar.propTypes = {
  showPrint: PropTypes.bool,
  noPadding: PropTypes.bool,
};

export const PDFDownload = ({ mutation }) => {
  const { onDownload, isDownloadInProgress } = useDownload(mutation);

  return (
    <span className={styles.download}>
      <TextButton data-download-pdf-button isLoading={isDownloadInProgress} onClick={onDownload}>
        <Icon size="lg" icon="download" />
        <span>
          <Text t="projects.download_pdf" />
        </span>
      </TextButton>
    </span>
  );
};

export default HelpBar;
